var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#2852ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.66 26.022c3.907-3.95 8.877-5.924 14.91-5.924 8.073 0 13.975 2.647 17.708 7.942 2.062 2.974 3.168 5.957 3.32 8.952H56.572c-.65-2.3-1.486-4.036-2.506-5.208-1.823-2.083-4.525-3.125-8.106-3.125-3.645 0-6.521 1.47-8.626 4.41-2.105 2.941-3.158 7.102-3.158 12.484s1.113 9.413 3.337 12.094c2.224 2.68 5.051 4.02 8.48 4.02 3.515 0 6.196-1.15 8.04-3.45 1.02-1.238 1.867-3.093 2.54-5.567H66.5c-.868 5.23-3.087 9.483-6.657 12.76-3.57 3.277-8.144 4.916-13.721 4.916-6.901 0-12.326-2.214-16.276-6.641-3.95-4.449-5.925-10.547-5.925-18.294 0-8.377 2.247-14.833 6.739-19.369Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.0524ba9e8a2d66555c0de7dac923af04.svg";
export { ForwardRef as ReactComponent };